import type { ReactNode } from 'react';

/** 차트 섹션 공통 wrapper — 제목 + 카드 박스 */
export function ChartCard({
  title,
  subtitle,
  children,
  className = '',
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section
      className={
        'rounded-2xl border border-[var(--color-border)] bg-[var(--color-surface)] p-4 ' +
        className
      }
    >
      <header className="mb-3">
        <h3 className="text-sm font-semibold text-[var(--color-text)]">{title}</h3>
        {subtitle && <p className="mt-0.5 text-xs text-[var(--color-text-sub)]">{subtitle}</p>}
      </header>
      {children}
    </section>
  );
}

/** 데이터 부족 시 표시 */
export function ChartEmpty({ message = '차트 데이터를 불러올 수 없어요.' }: { message?: string }) {
  return (
    <div className="flex h-40 items-center justify-center rounded-md border border-dashed border-[var(--color-border)] text-xs text-[var(--color-text-sub)]">
      {message}
    </div>
  );
}
